import { getHostname, getPathname } from './dom.js';
import { getCurrentCulture as getCurrentCulture$1 } from '../../../../culture-resolution-core/build/module/lib/culture.js';

var getCurrentCulture=function(){var hostname=getHostname();var pathname=getPathname();return getCurrentCulture$1(hostname,pathname)};

export { getCurrentCulture };
//# sourceMappingURL=culture.js.map
